/** @jsx jsx */
import { jsx, Container } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import { FluidImage as ImageType } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Styles
import { baseStyle } from './style';

// Components
import CustomGrid from '../customGrid';
import Card from '../card';
import classNames from 'classnames';
import { PageSelector } from '../../@types/pageselector';

export interface CardItem {
  card: {
    fieldGroupName?: string;
    label?: string;
    subtitleTitle?: string;
    target?: string;
    textarea?: string;
    title?: string;
    url?: string;
    image?: ImageType;
    titleinimageTrueFalse: boolean;
    pageSelector: PageSelector;
  };
}

export interface CardGridProps {
  className?: string;
  cards: CardItem[];
}

const CardGrid: FunctionComponent<CardGridProps> = React.memo(
  ({ cards, className }) => (
    <Container
      className={classNames('CardGrid', className)}
      sx={baseStyle.mainContainer}
    >
      <CustomGrid>
        {cards.map(item => (
          <Card
            category=""
            title={
              item.card.titleinimageTrueFalse
                ? item.card.textarea || ''
                : item.card.title || ''
            }
            content={item.card.titleinimageTrueFalse ? '' : item.card.textarea}
            image={item.card.image}
            titleInImage={
              item.card.titleinimageTrueFalse ? item.card.title : ''
            }
            cta={{
              label: '',
              target: '',
              url: item.card.url || item.card.pageSelector?.uri,
            }}
            sx={baseStyle.card}
          />
        ))}
      </CustomGrid>
    </Container>
  ),
);

export default CardGrid;
